import React, { useEffect, useState } from "react";
import styles from "./TopNavbar.module.css";
import { CartButton } from "../Buttons/CartButton/CartButton";
import { PrintCardsButton } from "../Buttons/PrintCardsButton/PrintCardsButton";

const TopNavbar: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [lastScrollY, setLastScrollY] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollThreshold = 100; // Minimum scroll distance to trigger hide/show

      // Hide/show navbar based on scroll direction
      if (currentScrollY < scrollThreshold) {
        // Always show navbar when near the top
        setIsVisible(true);
      } else if (
        currentScrollY > lastScrollY &&
        currentScrollY > scrollThreshold
      ) {
        // Scrolling down - hide navbar
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up - show navbar
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <div className={`${styles.topNavbar} ${!isVisible ? styles.hidden : ""}`}>
      <img src="/images/logo/logoWithBg.svg" alt="Logo" />
      <div className={styles.navLinks}>
        <CartButton />
        <PrintCardsButton />
      </div>
    </div>
  );
};

export default TopNavbar;
